<template>
    <div>
        <!-- Dialog Begin -->
        <el-dialog
            title="Import from CSV"
            :visible.sync="dialogTableVisible"
            :before-close="handleClose"
            v-loading.fullscreen="loading"
        >
            <!-- <el-upload
                class="upload-demo"
                drag
                :stored="file"
                accept=".xls, .xlsx, .csv, .ods"
                action
                :http-request="loadCSV"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Suelta tu archivo aquí o
                    <em>haz clic para cargar</em>
                </div>
                <div
                    slot="tip"
                    class="el-upload__tip"
                >Solo archivos .xls, .xlsx, .csv menor de 500kb</div>
            </el-upload>-->
            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload"/>

            <!-- Table BEGIN -->
            <template>
                <el-table
                ref="multipleTable"
                :data="tableData"
                border
                highlight-current-row
                style="width: 100%;margin-top:20px;"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column
                    v-for="item of tableHeader"
                    :prop="item"
                    :label="item"
                    :key="item"
                />
            </el-table>
                <!-- <el-table
                    ref="multipleTable"
                    :data="parse_csv"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="55"></el-table-column>

                    <el-table-column property="categoryId" label="Category Id" width="120"></el-table-column>

                    <el-table-column
                        property="categoryName"
                        label="Category Name"
                        show-overflow-tooltip
                    ></el-table-column>

                    <el-table-column property="clubName" label="Club Name" show-overflow-tooltip></el-table-column>

                    <el-table-column
                        property="managerEmail"
                        label="Manager Email"
                        show-overflow-tooltip
                    ></el-table-column>
                </el-table> -->

                <div style="margin-top: 20px">
                    <el-button
                        @click="save()"
                        :disabled="loading"
                        type="primary"
                        icon="el-icon-fa-floppy-o"
                    >Save</el-button>
                    <el-button @click="toggleSelection()">Clear selection</el-button>
                </div>
            </template>
            <!-- Table END -->
        </el-dialog>
        <!-- Dialog END -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import UploadExcelComponent from "@/components/UploadExcel";

import _ from "underscore";

/* eslint-disable */
export default {
    name: "app-club-list",
    components: { UploadExcelComponent },
    data() {
        return {
            dialogTableVisible: true,
            tableData: [],
            tableHeader: ['category', 'clubName', 'team', 'emailManager'],

            file: null,
            parse_header: [],
            parse_csv: [],
            multipleSelection: [],
            sortOrders: {},
            sortKey: ""
        };
    },

    computed: {
        ...mapGetters({
            loading: "entities/club/loading"
        })
    },

    filters: {
        capitalize: function(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created() {
        console.log("<--- created import");

        this.dialogTableVisible = true;
    },

    beforeRouteUpdate(to, from, next) {
        console.log(to, from);

        next();
    },

    methods: {
        sortBy: function(key) {
            var vm = this;
            vm.sortKey = key;
            vm.sortOrders[key] = vm.sortOrders[key] * -1;
        },

        csvJSON(csv) {
            var vm = this;
            var lines = csv.split("\n");
            var result = [];
            var headers = lines[0].split(",");
            vm.parse_header = lines[0].split(",");
            lines[0].split(",").forEach(function(key) {
                vm.sortOrders[key] = 1;
            });
            lines.map(function(line, indexLine) {
                if (indexLine < 1) return; // Jump header line
                var currentline = line.split(",");

                // Data
                var categoryId = "";
                var categoryName = "";
                var clubName = "";
                var managerEmail = "";

                headers.map(function(header, indexHeader) {
                    console.log(header);

                    // categoryId
                    if (header.trim() === `categoryId`) {
                        categoryId = currentline[indexHeader].trim();
                    } else if (header.trim() === `"categoryId"`) {
                        categoryId = currentline[indexHeader]
                            .trim()
                            .substring(1);
                        categoryId = categoryId
                            .trim()
                            .substring(0, categoryId.length - 1);
                    }

                    // categoryName
                    if (header.trim() === `categoryName`) {
                        categoryName = currentline[indexHeader].trim();
                    } else if (header.trim() === `"categoryName"`) {
                        categoryName = currentline[indexHeader]
                            .trim()
                            .substring(1);
                        categoryName = categoryName
                            .trim()
                            .substring(0, categoryName.length - 1);
                    }
                    // clubName
                    if (header.trim() === `clubName`) {
                        clubName = currentline[indexHeader].trim();
                    } else if (header.trim() === `"clubName"`) {
                        clubName = currentline[indexHeader].trim().substring(1);
                        clubName = clubName
                            .trim()
                            .substring(0, clubName.length - 1);
                    }

                    // managerEmail
                    if (header.trim() === `managerEmail`) {
                        managerEmail = currentline[indexHeader].trim();
                    } else if (header.trim() === `"managerEmail"`) {
                        managerEmail = currentline[indexHeader]
                            .trim()
                            .substring(1);
                        managerEmail = managerEmail
                            .trim()
                            .substring(0, managerEmail.length - 1);
                    }
                });

                var obj = {
                    categoryId: categoryId,
                    categoryName: categoryName,
                    clubName: clubName,
                    managerEmail: managerEmail
                };
                result.push(obj);
            });
            return result; // JavaScript object
        },

        loadCSV(e) {
            var vm = this;
            var reader = new FileReader();
            reader.readAsText(e.file);
            // Handle errors load
            reader.onload = function(event) {
                var csv = event.target.result;
                vm.parse_csv = vm.csvJSON(csv);
            };
            reader.onerror = function(evt) {
                if (evt.target.error.name == "NotReadableError") {
                    alert("Canno't read file !");
                }
            };
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        save() {
            var indeByClub = _.indexBy(this.multipleSelection, "clubName");
            var groupByClub = _.groupBy(this.multipleSelection, "clubName");

            // Clubs uniques
            _.forEach(indeByClub, (value, index, array) => {
                var clubToSave = {
                    name: value.clubName,
                    emailManager: value.managerEmail.trim(),
                    logo: {
                        name: "",
                        data: "",
                        size: 0
                    }
                };
                console.log("###### club to save");
                console.log(clubToSave);

                // Save club
                this.$store
                    .dispatch("entities/club/save", clubToSave)
                    .then(club => {
                        var teams = groupByClub[index];

                        _.forEach(teams, (value, index, array) => {
                            var teamToSave = {
                                category: {
                                    id: value.categoryId,
                                    label: value.categoryName
                                },
                                club: {
                                    id: club.id,
                                    name: club.name
                                },
                                name: value.teamName
                            };
                            this.$store
                                .dispatch("entities/team/save", teamToSave)
                                .then(() => {});
                            console.log("###### TEAM");
                            console.log(teamToSave);
                        });
                    });
            });
            console.log("NUM");

            console.log(_.size(groupByClub));

            //   this.multipleSelection.forEach((it, index, array) => {
            //        this.$store.dispatch("entities/club/save", it).then(() => {
            //         console.log(index);
            //         console.log(it);
            //         if (index == array.length - 1 ) {
            //           this.file = null
            //           this.parse_csv = []
            //           this.multipleSelection = []
            //           this.dialogTableVisible = false
            //           this.$router.go(-1)
            //         }
            //       });
            //   })
        },

        handleClose(done) {
            this.$confirm("Are you sure to close this dialog?")
                .then(_ => {
                    done();
                    this.$router.go(-1);
                })
                .catch(_ => {});
        },
        // Functions upload excel
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess({ results, header }) {
            this.tableData = results;
            this.tableHeader = header;
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/club/club-import-csv.vue?8c056134